<template>
    <div id="chartdiv8"></div>
</template>

<script>
    import * as am4core from "@amcharts/amcharts4/core";
    import * as am4charts from "@amcharts/amcharts4/charts";
    import am4themes_animated from "@amcharts/amcharts4/themes/animated";
    import API from '@/api'
    import { inject } from "vue";
    export default {
        props: ['date_from', 'date_to', 'projectID'],
        // inject: ['date_from', 'date_to','showLocationData'],
        data() {
            return {
                form: {
                    date_from: '',
                    date_to: '',
                    client_id: '',
                    projectID: ''
                },
                datacollection: {
                    labels: [],
                    datasets: [{
                        data: [],
                    }]
                },
            }
        },
        beforeMount() {
            this.form.date_from = this.date_from;
            this.form.date_to = this.date_to;
            this.selected_client_id = JSON.parse(localStorage.getItem('client_id'));
            this.form.client_id = this.selected_client_id;
            this.form.projectID = this.projectID;
            this.getChartData();
        },
        mounted() {
            this.form.projectID = this.projectID;
        },
        created() {
            // this.$EventBus.$on("filterByDate", (data) => {
            //     this.getFormData(data);
            // });
            // this.$EventBus.$on("resetForm", (data) => {
            //     this.getFormData(data);
            // });
        },
        methods: {
            getFormData(data) {
                this.form.date_from = data.date_from;
                this.form.date_to = data.date_to;
                this.form.projectID = data.project_id || this.projectID;
                this.updateChartData()
            },
            getChartData() {
                // const date_form = inject("date_form", date_form);
                // console.log('date_form D :', date_form);
                // const date_to = inject("date_to", date_to);
                this.form.date_from = this.date_from || this.form.date_from;
                this.form.date_to = this.date_to || this.form.date_to;
                this.form.projectID = this.projectID;
                API.getSpotPerLocation(this.form,
                    data => {
                        var sportArray = data.data
                        console.log(data.data);
         
                        am4core.useTheme(am4themes_animated);
                        let chart = am4core.create("chartdiv8", am4charts.XYChart);
                        if(chart.logo){
                            chart.logo.disabled = true;
                        }
                        chart.data = sportArray;
                        console.log('ChartData',chart.data);
                        // Create axes

                        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
                        categoryAxis.dataFields.category = "location_name";
                        categoryAxis.renderer.grid.template.location = -12;
                        categoryAxis.renderer.minGridDistance = 30;
                        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

                        // Create series
                        let series = chart.series.push(new am4charts.ColumnSeries());
                        series.dataFields.valueY = "location_count";
                        series.dataFields.categoryX = "location_name";
                        series.name = "location_count";
                        series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
                        series.columns.template.fillOpacity = .8;

                        let columnTemplate = series.columns.template;
                        columnTemplate.strokeWidth = 2;
                        columnTemplate.strokeOpacity = 1;
                        chart.responsive.enabled = true;
                        
                    },
                    err => {
                    }
                )
            },
            updateChartData() {
                API.getSpotPerLocation(this.form,
                    data => {
                        var sportArray = data.data         
                        am4core.useTheme(am4themes_animated);
                        let chart = am4core.create("chartdiv8", am4charts.XYChart);
                        if(chart.logo){
                            chart.logo.disabled = true;
                        }
                        chart.data = sportArray;
                        console.log('ChartData',chart.data);
                        // Create axes

                        let categoryAxis = chart.xAxes.push(new am4charts.CategoryAxis());
                        categoryAxis.dataFields.category = "location_name";
                        categoryAxis.renderer.grid.template.location = -12;
                        categoryAxis.renderer.minGridDistance = 30;
                        let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

                        // Create series
                        let series = chart.series.push(new am4charts.ColumnSeries());
                        series.dataFields.valueY = "location_count";
                        series.dataFields.categoryX = "location_name";
                        series.name = "location_count";
                        series.columns.template.tooltipText = "{categoryX}: [bold]{valueY}[/]";
                        series.columns.template.fillOpacity = .8;

                        let columnTemplate = series.columns.template;
                        columnTemplate.strokeWidth = 2;
                        columnTemplate.strokeOpacity = 1;
                        chart.responsive.enabled = true;
                    },
                    err => {
                    }
                )
            },
        },
        watch: {
            projectID(newProjectID) {
                if (newProjectID) {
                    this.getChartData();
                }
            }
        }
    }
</script>

<style >
body {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
}

#chartdiv8{
  width: 100%;
  height: 330px;
}

</style>